/** Mirrors src/backend/auth/password.js — the server is the authority; this only
 * lets the forms say the rule before a round trip. */
export const MIN_PASSWORD_LENGTH = 12;
